import(/* webpackMode: "eager" */ "/home/runner/work/lifti-office-frontend/lifti-office-frontend/src/app/layout.tsx");
